<template>
<div class="mt-15 mb-5">
 <v-sheet class="pa-2">
   <v-row
          justify="space-around"
          no-gutters
        >
        <v-col cols="6">
    <v-switch class="ml-6"
      v-model="isMultiple"
      flat
      :label="Multiple_label"      
    ></v-switch> 
        </v-col> 
   
          <v-col cols="6">
            <v-menu
              ref="startMenu"
              :close-on-content-click="false"
              :return-value.sync="trip.start"
              offset-y
              min-width="290px"              
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="trip.start"
                  label="Today date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"                  
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.startMenu.isActive = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.startMenu.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
   </v-row>
</v-sheet>
<v-slide-group
    v-model="dateCardModel"
    :multiple = "isMultiple"
    show-arrows
    >
    <v-slide-item
        v-for="(date,index) in date_range"
        :key="index"
        v-slot="{ active, toggle}"
    >    
    <v-card
    :color="active ? 'primary' : 'lighten-1'"
    class="mx-auto"
    max-width="344"
    @click="toggle"
  >
    <v-card-text>
      <div> {{ formatdate(date) }} </div>
      <!-- <p class=" text--primary">
        Breakfast
      </p>     -->
      <p class=" text--primary">{{ formatday(date) }}</p>
      <!-- <div class="text--primary">
       Dinner
      </div> -->
    </v-card-text>
    <v-card-actions>   
      <!-- <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon> -->
         <v-btn
        text
        color="blue"
      >
      Add
        <!-- {{ formatday(date) }} -->
      </v-btn>
      <!-- <v-icon
        small
        @click="viewItem(item)"
      >
        mdi-eye
      </v-icon> -->
    </v-card-actions>
  </v-card>
    </v-slide-item>
</v-slide-group>
<v-expand-transition>
    <v-sheet
      v-if="dateCardModel != null"
      height="150"
      tile
    >
      <v-row
        class="fill-height"
        align="center"
        justify="center"
      >
      <p class="text">
        Date on: {{ selecteddateformat(date_range[dateCardModel]) }}
      </p>    
    <v-expansion-panels popout class="mb-3">
      <v-expansion-panel
        v-for="(time,i) in dietOptions"
        :key="i"
      >
        <v-expansion-panel-header 
        expand-icon="mdi-menu-down">
         
          <v-row
              align="center"
              class="spacer"
              no-gutters
            >
              <v-col
                cols="4"
                sm="2"
                md="1"
              >
               {{i}}
                <!-- <v-avatar
                  size="36px"
                >
                  <img
                    
                    alt="Avatar"
                    src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                  >
                   <v-icon
                    v-else
                    :color="time.color"
                    v-text="time.icon"
                  ></v-icon> 
                </v-avatar> -->
              </v-col>

              <v-col
                class="hidden-xs-only"
                sm="5"
                md="3"
              >
                <strong v-html="selectedDiet[time]"></strong>
                <strong v-html="time"></strong>
                
                <!-- <span
                  v-if="time.total"
                  class="grey--text"
                >
                  &nbsp;({{ time.total }})
                </span> -->
              </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- <v-card flat>
          <v-card-text> -->
            <!-- <v-container fluid> -->
              <v-row>                
                <v-col
                  cols="12"
                  sm="4"
                  md="4"                  
                  v-for="(ex,i) in time"
                  :key="i"
                >
                  <v-checkbox   
                    :v-model="selectedDiet[ex]"                                  
                    :label="ex"
                    color="blue"
                    :value="ex"
                    hide-details
                  > </v-checkbox>
                </v-col>
              </v-row>
            <!-- </v-container> -->
          <!-- </v-card-text>
          </v-card> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="text-center">
    <v-btn
      rounded
      color="primary"
      dark
    >
      Save Diet
    </v-btn>
    </div>    
    </v-row>     
  </v-sheet>
  </v-expand-transition>



  </div>
</template>
<script>
// import Lunchmenu from '../components/Lunchmenu.vue';
import moment from "moment";
export default {
    components: {
    // Lunchmenu
  },
  data () {
      return {
        e1: 1,
        steps: 4,
        times: ['Breakfast','Lunch','Dinner'],
        dateCardModel: null,
        isMultiple: false,
        foodSchedule: { 
          date: [],
        },
        date:null,
        trip: {
          name: '',
          location: null,
          start: null,
          end: null,
        },
        dietOptions:{
          breakfastMain: ['Puttu', 'Uppama', 'Appam',],
          breakfastCurry: ['Kadala', 'Chicken'],
          lunchMain: ['Fried Rice','Rice',],
          lunchCurry: ['Soyabean Masala','Fish Curry'],
          dinnerMain: ['Chappati','Poratta'],
          dinnerCurry: ['Greenpiece','Beef curry']
        },
        selectedDiet:{
          breakfastMain: [],
          breakfastCurry:[],
          lunchMain:[],
          lunchCurry:[],
          dinnerMain:[],
          dinnerCurry:[]
        },
        ex4: ['red', 'indigo', 'orange',],
      }
    },
    computed:{
      selective_range(){
        // let thirdday = moments
        const start = new Date("11/3/2022"), end = new Date("12/3/2022")
        const range = moment.range(moment(start), moment(end));
        return range
      },
      today(){        
        return moment()
      },
      date_range(){
        // let today     = moment();
        // let tomorrow  = moment().add(1,'days');
        let type = 'days';
        let fromDate = moment().add(2, 'days');
        let toDate = moment().add(9,'days');
        let diff = toDate.diff(fromDate, type)
        let range = []
        for (let i = 0; i < diff; i++) {
          range.push(moment(fromDate).add(i, type))
        }
        return range
      },
      Multiple_label(){
        return this.isMultiple ? "Multiple Days" :"Single Day"
      }
    },

    watch: {
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
    },

    methods: {
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      formatdate(date){      
        return(moment(date).format('DD-MM-YYYY'))
      },
      formatday(date){
        return(moment(date).format('dddd'))
      },
      selecteddateformat(date){
         return(moment(date).format('ddd DD-MM-YY'))
      },
      thisday(dateCardModel){
        this.foodSchedule.date.push(this.date_range[dateCardModel]);
        console.log(this.foodSchedule.date)
      }
    },
    created(){
      this.trip.start = this.formatdate(this.today)
    }
}
</script>



    <!-- <v-card class=" mt-5 mb-4">
       <v-sheet
            class="mx-auto"
            max-width="700"
        >
            <v-slide-group
            multiple
            show-arrows
            >
            <v-slide-item
                v-for="n in times"
                :key="n"
                v-slot="{ active, toggle }"
            >
                <v-btn
                class="mx-2"
                :input-value="active"
                active-class="purple white--text"
                depressed
                rounded
                @click="toggle"
                >
                 {{ n }} Options
                </v-btn>
            </v-slide-item>
            </v-slide-group>
        </v-sheet>-->
      
      <!-- <v-card-text>
        <v-select
          v-model="steps"
          :items="[2, 3, 4, 5, 6]"
          label="# of steps"
        ></v-select> 
      </v-card-text>-->
    <!--</v-card>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="e1 > n"
            :step="n"
            editable
          >
            Step {{ n }}
          </v-stepper-step>

          <v-divider
            v-if="n !== steps"
            :key="n"
          ></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          v-for="n in steps"
          :key="`${n}-content`"
          :step="n"
        >
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="200px"
          >
          <v-sheet
            class="mx-auto"
            max-width="700"
        >
            <v-slide-group
            multiple
            show-arrows
            >
            <v-slide-item
                v-for="n in times"
                :key="n"
                v-slot="{ active, toggle }"
            >
                <v-btn
                class="mx-2"
                :input-value="active"
                active-class="purple white--text"
                depressed
                rounded
                @click="toggle"
                >
                 {{ n }} Options
                </v-btn>
            </v-slide-item>
            </v-slide-group>          
        </v-sheet>
        <v-radio-group
        v-model="row"
        row
        label='Rice'
        >
        <v-radio
            label="Qtr"
            value="radio-1"
        ></v-radio>
        <v-radio
            label="Half"
            value="radio-2"
        ></v-radio>
        <v-radio
            label="Full"
            value="radio-3"
        ></v-radio>  
        
              
        </v-radio-group> -->
        <!-- <v-container fluid>
        <v-row>
          <v-col cols="12">
             v-model="" 
            <v-slider
              
              :max="255"
              label="Chappathi"
              class="align-center"
            >
              <template v-slot:append>
                  v-model="red" 
                <v-text-field
                 
                  class="mt-0 pt-0"
                  type="number"
                  style="width: 60px"
                ></v-text-field>
              </template>
            </v-slider>
          </v-col>

         
        </v-row>
      </v-container>


          </v-card>

          <v-btn
            color="primary"
            @click="nextStep(n)"
          >
            Continue
          </v-btn>

          <v-btn text>
            Cancel
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper> -->
